import { PACK_BY_ID } from './packData.js';
import {
  FilterChipToggle,
  FilterChipsRow,
} from '../../design-system/patterns/index.js';
import './RecipePacks.css';

/**
 * PackFilterChips — "From packs" row shown in Browse filter area.
 * Renders one chip per added pack with pack-swatch adornment.
 * Clicking the chip toggles the filter; × clears the active filter.
 */
export default function PackFilterChips({ addedPackIds, activePackFilter, onTogglePackFilter }) {
  return (
    <FilterChipsRow
      label="From packs"
      emptyText={!addedPackIds || addedPackIds.size === 0 ? 'None added yet' : undefined}
    >
      {[...(addedPackIds || [])].map((packId) => {
        const pack = PACK_BY_ID[packId];
        if (!pack) return null;
        const isActive = activePackFilter === packId;
        return (
          <FilterChipToggle
            key={packId}
            label={pack.name}
            active={isActive}
            onClick={() => onTogglePackFilter?.(isActive ? null : packId)}
            onClear={() => onTogglePackFilter?.(null)}
            clearLabel={`Clear ${pack.name} filter`}
            title={`Filter to ${pack.name}`}
            adornment={(
              <span className="rp-filter-chip-swatch">
                {pack.swatches.slice(0, 4).map((s, i) => (
                  <span key={i} className="rp-filter-swatch-cell" style={{ '--rp-swatch-bg': s }} />
                ))}
              </span>
            )}
          />
        );
      })}
    </FilterChipsRow>
  );
}
